import { createServerFn } from '@tanstack/react-start';
import api from '../utils/api';

export const getFaq = createServerFn()
    .validator((data) => data)
    .handler(async ({ data }) => {
        const response = await api('get', 'faq', data);
        return response.data || {};
    });
